import { dataSmiley } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSmiley = /*#__PURE__*/createIcon(dataSmiley)
export default IconSmiley
